<div data-cy="permission-list">
  <ng-container *ngFor="let permission of featurePermissions; let i = index">
    <section
      *ngIf="permission.visible"
      data-cy="permission-list">
      <span>
        <mat-checkbox
          [attr.data-cy]="permission.value"
          [hidden]="permission.visible"
          [disabled]="permission.disabled || false"
          [checked]="permission.checked"
          [indeterminate]="someComplete(permission)"
          (change)="setAll($event.checked, permission)">
          {{
            (permission.translationString | i18n) ||
              permission.translationString
          }}
        </mat-checkbox>
      </span>
      <span>
        <ul>
          <li *ngFor="let subPermission of permission.subPermission">
            <mat-checkbox
              [attr.data-cy]="permission.value + '-' + subPermission.value"
              [disabled]="subPermission.disabled || false"
              [(ngModel)]="subPermission.checked"
              (ngModelChange)="updateAllComplete(permission)">
              {{
                (subPermission.translationString | i18n) ||
                  subPermission.translationString
              }}
            </mat-checkbox>
          </li>
        </ul>
      </span>
    </section>
  </ng-container>
</div>
